import { type Middleware } from '@reduxjs/toolkit';
import { conditionsStyleIds, updateDynamicStyleIds } from '@alltrails/maps';
import ConditionsRootState from './ConditionsRootState';
import { middlewareOnly_updateActiveCondition, updateIsPlayingOverlay, updatePreloadedOverlayUTCs } from './conditionsSlice';

const conditionsMiddleware: Middleware<{}, ConditionsRootState> =
  ({ dispatch, getState }) =>
  next =>
  action => {
    const result = next(action);
    const updatedState = getState();
    const dynamicStyleIds = updatedState.map.dynamicStyleIds || [];

    const activeCondition = updatedState.conditions.activeCondition;
    const updatedActiveCondition = conditionsStyleIds.find(id => dynamicStyleIds.includes(id));

    // When a DynamicStyleId change involves a ConditionStyleId, update the active condition and reset state
    if (activeCondition !== updatedActiveCondition) {
      dispatch(middlewareOnly_updateActiveCondition(updatedActiveCondition));
      dispatch(updatePreloadedOverlayUTCs(updatedState.conditions.selectedUTC ? [updatedState.conditions.selectedUTC] : []));
      dispatch(updateIsPlayingOverlay(false));
    }

    // When a user selects groundConditions, automatically select surfaceType
    if (updatedActiveCondition === 'groundConditions' && !dynamicStyleIds.includes('surfaceType')) {
      dispatch(updateDynamicStyleIds([...dynamicStyleIds, 'surfaceType']));
    }

    // When a user unselects groundConditions, automatically unselect surfaceType
    if (activeCondition === 'groundConditions' && updatedActiveCondition !== 'groundConditions') {
      if (dynamicStyleIds.includes('surfaceType')) {
        dispatch(updateDynamicStyleIds(dynamicStyleIds.filter(id => id !== 'surfaceType')));
      }
    }

    return result;
  };

export default conditionsMiddleware;
